import Element from 'element-ui';
// import '@stylesheets/element-variables.scss';
import Vue from 'vue';

Vue.use(Element);
